import ca from '../../di/cian_analytics';

export interface IPhoneShowGaStatProducts {
  id: number;
  price: number;
  brand: string;
  category: string;
  variant: string;
  quantity: number;
}

export const phoneShowGaStat = (type: string, offerType: string, products: IPhoneShowGaStatProducts) => {
  ca('event', {
      name: 'oldevent',
      category: 'Phones',
      action: type,
      label: offerType,
      user: (window as any)._dataLayerBackedObject.user,
      products,
  });
};



// WEBPACK FOOTER //
// ./src/bundles/offer/tracking.ts